export default {
  'createBill.purchaseorderno': 'رقم أمر الشراء:',
  // "createBill.phone": "Phone",
  'createBill.IranBranchOffice,No.18,AlvandBuilding,AlvandSt.ArgentinaSq.,Tehran,Iran.Phone:+98 21 88663088': `
مكتب الفرع في إيران، رقم 18، مبنى الألواند، شارع الألواند، ساحة الأرجنتين، طهران، إيران.
الهاتف: +98 21 88663088`,
  // "createBill.argentina": "Argentina Sq., Tehran, Iran.",
  'createBill.date': 'التاريخ',
  'createBill.supplieraddress': 'عنوان المورد:',
  'createBill.3061valiasrsttehraniran': '3061، شارع ولي عصر، طهران، إيران',
  'createBill.requestername': 'اسم المطلوب',
  'createBill.paymentterms': 'شروط الدفع',
  'createBill.frominvoicereceipt': 'من إيصال الفاتورة',
  'createBill.projectname': 'اسم المشروع:',
  'createBill.test': 'اختبار',
  'createBill.pos': 'نقطة البيع',
  'createBill.description': 'الوصف',
  'createBill.quantity': 'الكمية',
  'createBill.uom': 'وحدة القياس',
  'createBill.netprice': 'السعر الصافي',
  'createBill.per': 'لكل',
  'createBill.totalprice': 'السعر الإجمالي',
  'createBill.curr': 'العملة',
  'createBill.deliverydate': 'تاريخ التسليم',
  'createBill.NECfullHD1024': 'إن إي سي - عالية الوضوح 1024',
  'createBill.sonyultraHD': 'سوني - فائقة الوضوح',
  'createBill.xiaominormalheadset': 'شاومي - سماعة عادية',
  'createBill.beatshighqualitywireless': 'بيتس - عالية الجودة - لاسلكية',
  'createBill.totalgrossamount':
    'إجمالي القيمة الإجمالية (بما في ذلك الضريبة إن وجدت)',
  'createBill.months': 'شهور',
  'createBill.hours': 'ساعات',
  'createBill.days': 'أيام',
  'createBill.novartispharmaserviceAG': 'شركة نوفارتيس لخدمات الصيدلة',
};
